var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGapX18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2v-2h-1V4h1V2zM4 16H2v-2h1V4H2V2h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zM10 11a1 1 0 1 1-2 0V7a1 1 0 0 1 2 0v4z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0xNiAyaC0yYTEgMSAwIDAgMC0xIDF2MTJhMSAxIDAgMCAwIDEgMWgydi0yaC0xVjRoMVYyek00IDE2SDJ2LTJoMVY0SDJWMmgyYTEgMSAwIDAgMSAxIDF2MTJhMSAxIDAgMCAxLTEgMXpNMTAgMTFhMSAxIDAgMSAxLTIgMFY3YTEgMSAwIDAgMSAyIDB2NHoiLz48L3N2Zz4=";
export { SvgGapX18 as ReactComponent };